import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SDUIRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SDUIRenderer/SDUIRenderer";
import { calculateNumUPLTComponentsPerClientSize } from "@faire/retailer-visitor-shared/components/SDUI/UPLT/calculateNumComponentsPerClientSize";
import { MaybeSDUIUPLTWrapper } from "@faire/retailer-visitor-shared/components/SDUI/UPLT/MaybeSDUIUPLTWrapper";
import { PageInitialized } from "@faire/retailer-visitor-shared/events";
import { useBrowseLayoutQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/v3/useBrowseLayoutQuery";
import { useSDUICategoryPageUPLT } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useSDUICategoryPageUPLT";
import { useSDUIHubPageUPLT } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useSDUIHubPageUPLT";
import { useIsHubCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useIsHubCategory";
import { useIsSDUISeasonalHubPage } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useIsSDUISeasonalHubPage";
import { LoggedInCategoryPageLoadingSkeleton } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedInCategoryPageLoadingSkeleton";
import { MaybeAssignHubsRSCM1Setting } from "@faire/retailer-visitor-shared/views/category/HubsRSC/MaybeAssignHubsRSCM1Setting";
import { ViewLayoutPlacement } from "@faire/web-api--source/indigofair/data/ViewLayoutPlacement";
import * as React from "react";
import { useLayoutEffect } from "react";
export var SDUICategoryPageContents = function(param) {
    var componentRenderers = param.componentRenderers, sectionRenderers = param.sectionRenderers;
    var _useBrowseLayoutQuery = useBrowseLayoutQuery(ViewLayoutPlacement.TOP), topViewLayout = _useBrowseLayoutQuery.data, isTopLayoutLoading = _useBrowseLayoutQuery.isFetching;
    var isSeasonalHubCategory = useIsSDUISeasonalHubPage();
    var _useBrowseLayoutQuery1 = useBrowseLayoutQuery(ViewLayoutPlacement.FPS), fpsViewLayout = _useBrowseLayoutQuery1.data, isFPSLayoutLoading = _useBrowseLayoutQuery1.isFetching;
    var isHubCategory = useIsHubCategory().isHubCategory;
    var hubPageLoadTimingProps = useSDUIHubPageUPLT();
    var categoryPageLoadTimingProps = useSDUICategoryPageUPLT();
    var loadTimingProps = isHubCategory ? hubPageLoadTimingProps : categoryPageLoadTimingProps;
    useLayoutEffect(function() {
        if (isHubCategory && !isTopLayoutLoading) {
            PageInitialized.publish();
        } else if (!isHubCategory && !isFPSLayoutLoading) {
            PageInitialized.publish();
        }
    }, [
        isHubCategory,
        isTopLayoutLoading,
        isFPSLayoutLoading
    ]);
    var numUPLTComponentsPerClientSize = React.useMemo(function() {
        if (isHubCategory && topViewLayout) {
            return calculateNumUPLTComponentsPerClientSize(topViewLayout);
        }
        if (!isHubCategory && fpsViewLayout) {
            return calculateNumUPLTComponentsPerClientSize(fpsViewLayout);
        }
        return undefined;
    }, [
        isHubCategory,
        topViewLayout,
        fpsViewLayout
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MaybeAssignHubsRSCM1Setting, {
                isHubsCategory: isSeasonalHubCategory
            }),
            /*#__PURE__*/ _jsx(MaybeSDUIUPLTWrapper, _object_spread_props(_object_spread({}, loadTimingProps), {
                numComponentsPerClientSize: numUPLTComponentsPerClientSize,
                shouldTrackUPLT: isHubCategory,
                children: isTopLayoutLoading || topViewLayout === undefined ? null : /*#__PURE__*/ _jsx(SDUIRenderer, {
                    viewLayout: topViewLayout,
                    componentRenderers: componentRenderers,
                    sectionRenderers: sectionRenderers,
                    UPLTprops: {
                        shouldRenderBelowTheFold: !isHubCategory
                    }
                })
            })),
            /*#__PURE__*/ _jsx(MaybeSDUIUPLTWrapper, _object_spread_props(_object_spread({}, loadTimingProps), {
                numComponentsPerClientSize: numUPLTComponentsPerClientSize,
                shouldTrackUPLT: !isHubCategory,
                children: isFPSLayoutLoading || fpsViewLayout === undefined ? /*#__PURE__*/ _jsx(LoggedInCategoryPageLoadingSkeleton, {
                    isFullWidthCategoryPage: !isSeasonalHubCategory
                }) : /*#__PURE__*/ _jsx(SDUIRenderer, {
                    viewLayout: fpsViewLayout,
                    componentRenderers: componentRenderers,
                    sectionRenderers: sectionRenderers,
                    UPLTprops: {
                        shouldRenderBelowTheFold: false
                    }
                })
            }))
        ]
    });
};
